import { useAtom, useAtomValue } from "jotai";
import React, { useEffect } from "react";
import EventCardV2 from "src/components/layout/EventCardV2/EventCardV2";
import { S3_URL } from "src/config";
import styles from "src/features/Event/components/TopPageEventList/topPageEventList.module.css";
import baseStyles from "src/global.module.css";
import getUserIconUrl from "src/utils/getUserIconUrl";
import { isFirstFetchAtom, topPageEventListObjectAtom } from "../../event.atom";

const TopPageEventList: React.FC = () => {
    const [eventList, setEventList] = useAtom(topPageEventListObjectAtom);
    const isFirstFetch = useAtomValue(isFirstFetchAtom);

    useEffect(() => {
        if (!isFirstFetch) {
            setEventList(false);
        }
    }, [eventList, isFirstFetch, setEventList]);

    return (
        <>
            {Object.entries(eventList).map(([date, events]) => {
                return (
                    <React.Fragment key={date}>
                        <div
                            key={date}
                            className={styles.date_separator_container}
                        >
                            {date}
                        </div>
                        {events.map((event) => {
                            return (
                                <EventCardV2
                                    key={event.id}
                                    event={{
                                        event_id: event.id,
                                        title: event.title,
                                        thumbnail: event.thumbnail?.startsWith("http") ? event.thumbnail : `${S3_URL}/EventImages/${event.user_id}/${event.id}/Thumbnail/${event.thumbnail}`,
                                        start_time: event.start_time,
                                        finish_time: event.finish_time,
                                        place: event.place,
                                        eventType: event.event_type,
                                    }}
                                    likes={event.likes}
                                    comments_count={event.comments_count}
                                    bookmarks={event.bookmarks}
                                    user={{
                                        userId: event.user_id,
                                        username: event.user.name,
                                        userIconPath: getUserIconUrl(
                                            event.user.icon,
                                            event.user.id
                                        ),
                                        certification: event.user.certification,
                                    }}
                                />
                            );
                        })}
                        <div className={baseStyles.mb16} />
                    </React.Fragment>
                );
            })}
        </>
    );
};

export default TopPageEventList;
